export default __webpack_public_path__ + "static/media/Sofisticado.57308760.svg";